export const ANSWERS_LIMIT_REACHED =
  'The user has reached the limit of answers on this chapter';
export const NO_MORE_QUESTIONS_TEXT = 'The user has no questions to answer';
export const WARFARE_SUBSCRIPTION = 'The user has a warfare only subscription';
